import { ApiBitMask, ApiBitMaskTypes } from '../../../logger/bitMasks/ApiBitMask';
import { Logger } from '../../../logger/Logger';
import { DeferredParser } from '../../DeferredParser';
import { Fetcher } from '../../Fetcher';

import { playerConfigEndpoint } from './endpoints';
import { playerConfigParser } from './parsers';
import type { Compliance, IPlayerConfigResponse, PlayerConfigType } from './types';

export interface FetchPlayerConfigParams {
  JSESSIONID: string;
  baseUrl: string;
}

interface PlayerConfigPayload {
  parsedPlayerConfig: PlayerConfigType;
  rawResponse: IPlayerConfigResponse;
  compliance: Compliance;
}

export class PlayerConfigFetcherBase extends DeferredParser<FetchPlayerConfigParams, PlayerConfigPayload> {
  private operatorGameId?: string;
  private dedicatedLanguage?: string | null;
  private isCrashGame?: boolean;
  private currentLanguage?: string | null;

  constructor() {
    super(({ JSESSIONID, baseUrl }) =>
      Fetcher.fetch<unknown>(`${baseUrl}${playerConfigEndpoint.url}`, {
        params: {
          JSESSIONID,
        },
        format: playerConfigEndpoint.format,
        root: playerConfigEndpoint.root,
      })
    );
  }

  setOperatorGameId(operatorGameId: string): void {
    this.operatorGameId = operatorGameId;
    this.tryToParse();
  }

  setDedicatedLanguage(dedicatedLanguage: string | null): void {
    this.dedicatedLanguage = dedicatedLanguage;
    this.tryToParse();
  }

  setIsCrashGame(isCrashGame: boolean): void {
    this.isCrashGame = isCrashGame;
    this.tryToParse();
  }

  setCurrentLanguage(currentLanguage: string | null): void {
    this.currentLanguage = currentLanguage;
    this.tryToParse();
  }

  tryToParse(): void {
    if (this.operatorGameId !== undefined && this.dedicatedLanguage !== undefined && this.isCrashGame !== undefined) {
      const options = {
        operatorGameId: this.operatorGameId,
        dedicatedLanguage: this.dedicatedLanguage,
        isCrashGame: this.isCrashGame,
        currentLanguage: this.currentLanguage,
      };
      this.parseWith((data) => {
        ApiBitMask.apply(ApiBitMaskTypes.PlayerConfig);

        const { parsedConfig: parsedPlayerConfig, compliance } = playerConfigParser(
          data as IPlayerConfigResponse,
          options
        );
        const rawResponse = data as IPlayerConfigResponse;
        if (!parsedPlayerConfig.countryCode || parsedPlayerConfig.countryCode === '') {
          Logger.logFailure('emptyCountry');
        }
        return { parsedPlayerConfig, rawResponse, compliance };
      });
    }
  }
}

export const PlayerConfigFetcher = new PlayerConfigFetcherBase();
